export const FACEBLOCK_MODE = {
  BLUR: 'BLUR',
  WALDO_ICON: 'WALDO_ICON',
  CUSTOM_ICON: 'CUSTOM_ICON',
};

export const MATCHED_PHOTO_WATERMARK_MODE = {
  WALLPAPER: 'WALLPAPER',
  FACEBLOCK: 'FACEBLOCK',
  FACEBLOCK_AND_WALLPAPER: 'FACEBLOCK_AND_WALLPAPER',
};

export const WALLPAPER_WATERMARK_MODE = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
};

export const MATCHED_PHOTOS_METHOD = {
  FACEBLOCK: 'FACEBLOCK',
  WALLPAPER: 'WALLPAPER',
  FACEBLOCK_AND_WALLPAPER: 'FACEBLOCK_AND_WALLPAPER',
};
